export const TESTCASE1 = 'TESTCASE1';
export const TESTCASE_ADD_TO_ARRAY = 'TESTCASE-ADD-TO-ARRAY';
export const TESTCASE_DELETE_FROM_ARRAY = 'TESTCASE-DELETE-FROM-ARRAY';
